import { Equipment, Extractor } from "./equipment.model";

export class BalanceSheetModel {
  totalAirIntakesDebit = 0;
  totalAirLeakRate = 0;
  necessaryExtractorNumber = 0;
  necessaryEarNumber = 0;
  necessaryEacmNumber = 0;
  optionalNecessaryEacmNumber=0; /*Evolution Majeure composition de EACM*/
  minimumAirDebitToExtract = 0;
  bigExtractor: ExtractorDatas = new ExtractorDatas();
  smallExtractor: ExtractorDatas = new ExtractorDatas();
  minimalDepressionLeakRate = 0;
  depressionToMaintainLeakRate = 0;
  minimalDepressionRenewalRate = 0;
  depressionToMaintainRenewalRate = 0;
  totalMinExtractorCapacity = 0;
  totalMaxExtractorCapacity = 0;
  earCapacity = 0;
  windSpeedRate = 0;
}

export class ExtractorDatas {
  number = 0;
  extractor!: Extractor;
}
